import { Spinner } from "@aurem/ui";
import { useEffect, useRef } from "react";
import { useNotificationContext } from "../context";
import { NotificationEmpty } from "./NotificationEmpty";
import { NotificationItem } from "./NotificationItem";
import { NotificationListSkeleton } from "./NotificationListSkeleton";

export const NotificationList = () => {
  const {
    notifications,
    initialLoading,
    loading,
    hasMore,
    fetchPaginatedNotifications,
  } = useNotificationContext();

  const listRef = useRef<HTMLDivElement>(null);
  const isListVisible = !initialLoading && notifications.length > 0;

  useEffect(() => {
    if (!isListVisible) return;

    const OFFSET = 250;

    const handleScroll = () => {
      const container = listRef.current;
      if (!container || !hasMore) return;

      const { scrollTop, scrollHeight, clientHeight } = container;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - OFFSET;

      if (isNearBottom) {
        void fetchPaginatedNotifications();
      }
    };

    const container = listRef.current;
    if (!container) return;

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [isListVisible, hasMore, fetchPaginatedNotifications]);

  if (initialLoading) {
    return <NotificationListSkeleton />;
  }

  if (notifications.length === 0) {
    return <NotificationEmpty />;
  }

  return (
    <div
      ref={listRef}
      className="flex h-full min-h-0 flex-1 flex-col overflow-y-auto p-3 gap-px"
    >
      {notifications.map((notification) => (
        <NotificationItem key={notification.id} notification={notification} />
      ))}

      {loading && (
        <div className="flex justify-center py-3">
          <Spinner size="xs" />
        </div>
      )}
    </div>
  );
};
